// Vizit detayları penceresi (OperationManagement/VisitModal ve alt pencereleri).
// Bildirim (toast) ve doğrulama mesajları işlem kodunun içinde, eskisi gibi
// Türkçe kalır; burada yalnızca ekrandaki metinler var.
const visitModal = {
  title: 'Vizit Detayları',
  subtitleFallback: 'Saha operasyonu',
  subtitle: {
    patient: 'Hasta {{id}}',
    visitNo: '{{n}}. vizit',
  },
  modes: {
    completed: 'Tamamlandı',
    restricted: 'Görüntüleme ve silme',
    readOnly: 'Salt okunur',
    adminEditable: 'Admin · düzenlenebilir',
    mirror: 'Hibrit eş vizit',
  },
  notices: {
    restricted: 'Bu hesapla vizitleri yalnızca görüntüleyebilir ve silebilirsiniz; değişiklik kaydedilemez.',
    readOnly: 'Bu vizitin tamamlama süresi doldu (son gün + 72 saat). Bilgileri görüntüleyebilirsiniz ancak değiştiremezsiniz. Düzeltme gerekiyorsa yöneticinize başvurun.',
    adminEditable: 'Bu vizitin tamamlama süresi doldu. Admin yetkinizle yine de düzenleyip kaydedebilirsiniz.',
    mirror: 'Hibrit proje eş viziti: bu vizit, {{name}} tarafından açılan vizitle birlikte takviminize otomatik eklendi.',
    mirrorDefaultName: 'blinded çalışan',
    mirrorSourceDeleted: 'Kaynak vizit sonradan silindi.',
    pendingTitle: 'Eksik tamamlanma tarihi: {{items}}',
    pendingText: 'Bu vizit tamamlandı ancak bu tarihler henüz girilmedi. “Visit Değerlendirme” adımındaki “D — Tamamlanma Tarihleri” bölümünden girip kaydettiğinizde uyarı kalkar.',
    pendingAction: 'D bölümüne git',
    deadlineTitle: 'Vizit süresi doldu',
    deadlineText: 'Vizit bitişi: {{end}} · Son tamamlama: {{deadline}}',
    deadlineHours_one: '{{count}} saat kaldı',
    deadlineHours_other: '{{count}} saat kaldı',
  },
  progress: {
    title: 'İlerleme',
    percent: '%{{value}}',
    ready: 'Tamamlamaya hazır',
    readyHint: 'Zorunlu alanların hepsi dolu. “Ziyareti Tamamla” ile viziti kapatabilirsiniz.',
    missing_one: 'Tamamlamak için {{count}} alan eksik',
    missing_other: 'Tamamlamak için {{count}} alan eksik',
    missingHint: 'Turuncu adımlarda doldurulması gereken alanlar var.',
    stepOf: 'Adım {{current}} / {{total}}',
    stepsLabel: 'Vizit adımları',
    autosave: 'Anında kaydedilir',
  },
  status: {
    done: 'Tamam',
    missing_one: '{{count}} eksik',
    missing_other: '{{count}} eksik',
    optional: 'İsteğe bağlı',
    info: 'Bilgi',
    records_one: '{{count}} kayıt',
    records_other: '{{count}} kayıt',
    missingList: 'Eksik: {{items}}',
    missingFields: 'Eksik alanlar:',
  },
  steps: {
    informations: {
      label: 'Bilgiler',
      short: 'Proje ve hasta',
      title: 'Proje ve hasta bilgileri',
      help: 'Vizitin bağlı olduğu proje ve hasta bilgileri burada. Bu bilgiler proje kaydından gelir, değiştirmeniz gerekmez. Aşağıdaki adımları sırayla izleyerek vizit kaydını tamamlayabilirsiniz.',
    },
    todoList: {
      label: 'Yapılacaklar',
      short: 'Vizit öncesi ve sonrası kontroller',
      title: 'Yapılacaklar listesi',
      help: 'Vizit öncesinde ve sonrasında yapılması gereken kontrolleri işaretleyin. Vizit tamamlanmadan önce en az bir madde işaretli olmalıdır.',
    },
    visitForm: {
      label: 'Ziyaret Formu',
      short: 'Tür, saat, hasta ve konum',
      title: 'Ziyaret formu',
      help: 'Vizitin türünü, saatlerini, hastayı ve yapıldığı yeri girin. Yıldızlı (*) alanlar vizit tamamlanmadan önce doldurulmalıdır. Değişiklikleri alttaki “Kaydet” düğmesiyle kaydedin.',
    },
    stock: {
      label: 'Stok',
      short: 'Kullanılan malzemeler',
      title: 'Kullanılan malzemeler',
      help: 'Vizitte kullandığınız malzemeleri buradan ekleyin. Eklenen miktar size atanan stoktan hemen düşülür; kaldırdığınızda stoğa geri eklenir.',
    },
    shipments: {
      label: 'Kargo Takip',
      short: 'Gönderilen kargolar',
      title: 'Kargo takibi',
      help: 'Bu vizit için gönderdiğiniz numune, doküman veya malzeme kargolarını takip edin. Takip numarasını ve kargo belgelerini ekleyebilir, durumu tek dokunuşla güncelleyebilirsiniz.',
    },
    expenses: {
      label: 'Harcamalar',
      short: 'Ulaşım, konaklama, yemek…',
      title: 'Harcamalar',
      help: 'Vizit için yaptığınız ulaşım, konaklama, yemek gibi harcamaları fişi veya faturasıyla birlikte ekleyin.',
    },
    visitEvaluation: {
      label: 'Visit Değerlendirme',
      short: 'Pencere, süreç ve sonuç bilgileri',
      title: 'Vizit değerlendirmesi',
      help: 'Vizitin değerlendirme bilgilerini bölüm bölüm doldurun. Yıldızlı (*) alanlar vizit tamamlanmadan önce zorunludur. Değişiklikleri “Kaydet” ile kaydedin.',
      helpHome: 'Home vizit değerlendirmesi: vizit penceresi, yolculuk, vizit süresi ve kaynak doküman tarihleri.',
      helpSite: 'Hastane (site) vizit değerlendirmesi. “D — Tamamlanma Tarihleri” bölümü vizitin tamamlanmasını engellemez; tarihler sonradan da girilebilir.',
    },
    craApproval: {
      label: 'CRA Onay',
      short: 'CRA’ya onay e-postası',
      title: 'CRA onayı',
      help: 'Vizit bilgilerini onay için seçtiğiniz CRA’ya e-posta ile gönderin.',
    },
  },
  actions: {
    close: 'Kapat',
    back: 'Geri',
    next: 'İleri',
    nextTo: 'Sonraki adım: {{step}}',
    backTo: 'Önceki adım: {{step}}',
    save: 'Kaydet',
    saving: 'Kaydediliyor...',
    complete: 'Ziyareti Tamamla',
    completeShort: 'Tamamla',
    completing: 'Tamamlanıyor...',
    delete: 'Ziyareti Sil',
    deleting: 'Siliniyor...',
    cascadeDelete: 'Bu ve Sonraki Ziyaretleri Sil',
  },
  confirmDelete: {
    title: 'Vizit silinsin mi?',
    message: 'Bu ziyareti silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
    confirm: 'Evet, sil',
    cancel: 'Vazgeç',
  },
  common: {
    yes: 'Evet',
    no: 'Hayır',
    select: 'Seçiniz',
    pleaseSelect: 'Lütfen seçiniz',
    notSpecified: 'Belirtilmemiş',
    missing: 'Eksik',
    hours: 'Saat',
    minutes: 'Dakika',
    km: 'km',
    days_one: '{{count}} gün',
    days: '{{count}} gün',
    cancel: 'Vazgeç',
    readOnlyField: 'Bu alan otomatik doldurulur.',
  },
  info: {
    project: 'Proje adı',
    projectMissing: 'Proje bilgisi yüklenemedi',
    phase: 'Proje fazı',
    centersType: 'Proje koordinatör merkezi tipi',
    patientId: 'Hasta ID',
    visitNumber: 'Kaçıncı vizit',
    visitNumberValue: '{{n}}. Vizit',
    roadmapTitle: 'Bu vizitte izleyeceğiniz adımlar',
    roadmapHint: 'Bir adıma dokunarak doğrudan oraya geçebilirsiniz. Turuncu adımlarda vizit tamamlanmadan önce doldurulması gereken alanlar var.',
  },
  todo: {
    autosaveNote: 'İşaretlediğiniz maddeler anında kaydedilir; bu sayfa için “Kaydet”e basmanız gerekmez.',
    counter: '{{done}} / {{total}} madde işaretlendi',
    groups: {
      pre: {
        title: 'Vizit öncesi hazırlık',
        hint: 'Vizite çıkmadan önce kontrol edin.',
      },
      visit: {
        title: 'Vizit sırasında ve sonrasında',
        hint: 'Vizit sırasında ve vizitten sonra kontrol edin.',
      },
    },
    items: {
      pre_patientCalled: 'Hasta arandı mı?',
      pre_nurseTransferArranged: 'Hemşirenin ulaşımı (transferleri) ayarlandı mı?',
      pre_courierArranged: 'Vizitte toplanacak örnekler için kurye ve kurye malzemeleri (buz, kuru buz, kutu vb.) ayarlandı mı?',
      pre_hospitalApproval: 'İlaç sevkiyatı için hastane onayı alındı mı?',
      pre_nurseEquipmentReady: 'Hemşire vizitte kullanacağı ekipmanı hazırladı mı?',
      pre_accommodationPlanned: 'Gerekiyorsa konaklama planlandı mı?',
      patientConsent: 'Ev viziti için hasta onam formu alındı mı?',
      protocolUpdate: 'Protokol güncellemesi var mı? Varsa yeni onamlar alındı mı?',
      kvkkApproval: 'KVKK bilgilendirme onayı alındı mı?',
      visitNumberCheck: 'Vizit numarası kontrol edildi mi?',
      projectCheck: 'Proje bilgileri kontrol edildi mi?',
      workflowCheck: 'İş akışı (workflow) takibi yapıldı mı?',
      adverseEventCheck: 'Advers olay varsa sınıflandırması, takibi ve raporlaması yapıldı mı?',
      medicationCheck: 'Eşlik eden (konkomitan) ilaç takibi yapıldı mı?',
      sourceDocuments: 'Kaynak dokümanlar dolduruldu mu?',
      sourceDocumentsApproval: 'Vizitte doldurulan kaynak dokümanların paylaşımı için sponsor proje müdüründen onay alındı mı?',
      sourceDocumentsShared: 'Vizitte doldurulan kaynak dokümanlar çalışma ekibiyle e-posta ile paylaşıldı mı?',
      transferForm: 'Transfer formu dolduruldu mu?',
      documentShipping: 'Kaynak dokümanlar kargoya verildi mi?',
      stockEntryRequired: 'Stok girişi yapılacak mı?',
    },
    stockHint: 'İşaretlerseniz, Stok adımına en az bir malzeme girilmeden vizit tamamlanamaz.',
    goToStock: 'Stok adımına git',
    stockDone_one: '{{count}} malzeme girildi',
    stockDone_other: '{{count}} malzeme girildi',
    stockPending: 'Henüz malzeme girilmedi — vizit tamamlanamaz',
  },
  form: {
    sections: {
      type: {
        title: 'Vizit türü ve kaynak doküman',
        hint: 'Vizitin nasıl yapıldığını ve kaynak doküman doldurulup doldurulmadığını seçin.',
      },
      time: {
        title: 'Tarih ve saat',
        hint: 'Vizitin başladığı ve bittiği saatleri girin.',
      },
      patient: {
        title: 'Hasta ve hekim',
        hint: 'Viziti yaptığınız hastayı, vizit sırasını ve sorumlu hekimi girin.',
      },
      location: {
        title: 'Konum ve seyahat',
        hint: 'Hastaneyi seçtiğinizde şehir kendiliğinden dolar.',
      },
      notes: {
        title: 'Notlar',
        hint: 'Vizitle ilgili eklemek istediğiniz bilgiler.',
      },
    },
    visitType: 'Ziyaret tipi',
    visitTypes: {
      hastane: 'Hastane Vizit',
      home: 'Home Vizit',
      telefon: 'Telefon Vizit',
      unplanning: 'Unplanning Vizit',
      handover: 'Handover Vizit',
    },
    screenFail: 'Screen fail mi?',
    screenFailHint: 'Hasta tarama aşamasında çalışmaya uygun bulunmadıysa işaretleyin.',
    screenFailNote: 'Screen fail olarak işaretlenen kayıtlar ziyaret olarak sayılmaz, yapılan iş olarak kaydedilir.',
    sourceDocument: 'Kaynak doküman',
    sourceDocumentTime: 'Kaynak doküman tamamlanma saati',
    startDate: 'Vizit başlangıç tarihi',
    startDateHint: 'Tarih vizit planlanırken belirlenir ve buradan değiştirilemez.',
    startTime: 'Vizit başlangıç saati',
    endDate: 'Vizit bitiş tarihi',
    endDateHint: 'Kaydedildikten sonra değiştirilemez.',
    endTime: 'Vizit bitiş saati',
    patientId: 'Hasta ID',
    patientsLoading: 'Hastalar yükleniyor...',
    patientSelect: 'Hasta seçiniz',
    patientManual: 'Size ait kayıtlı hasta yok - manuel giriş yapabilirsiniz',
    patientHint: 'Yalnızca size ait hastalar ve daha önce vizit yaptığınız hastalar listelenir.',
    visitNumber: 'Kaçıncı vizit',
    visitNumberPlaceholder: 'Örn: 1, 2, 3...',
    doctor: 'Hekim',
    doctorPlaceholder: 'Hekimin adı soyadı',
    hospital: 'Hastane',
    hospitalsLoading: 'Hastaneler yükleniyor...',
    myCenters: 'Bu projedeki merkezleriniz',
    otherCenters: 'Diğer merkezler',
    centers: 'Merkezler',
    autoFilledProject: 'Proje atamanızdan dolduruldu, değiştirebilirsiniz.',
    autoFilledPrevious: 'Son ziyaretinizden dolduruldu, değiştirebilirsiniz.',
    city: 'Şehir',
    citiesLoading: 'Şehirler yükleniyor...',
    cityHint: 'Hastane seçtiğinizde otomatik güncellenir.',
    travelType: 'Seyahat tipi',
    travelTypes: {
      local: 'Şehir İçi',
      outside: 'Şehir Dışı',
    },
    information: 'Bilgi',
    informationPlaceholder: 'Vizitle ilgili eklemek istediğiniz notlar...',
  },
  fields: {
    visitType: 'Ziyaret tipi',
    sourceDocument: 'Kaynak doküman',
    date: 'Vizit başlangıç tarihi',
    startTime: 'Vizit başlangıç saati',
    endTime: 'Vizit bitiş saati',
    patientId: 'Hasta ID',
    doctor: 'Hekim',
    hospital: 'Hastane',
    city: 'Şehir',
    travelType: 'Seyahat tipi',
    anyTodo: 'En az bir işaretli madde',
    stockItem: 'En az bir malzeme kaydı',
    windowOpenDate: 'Pencere açılış',
    targetDate: 'Hedef tarih',
    windowCloseDate: 'Pencere kapanış',
    clinicianFullName: 'Klinisyen',
    travelBefore: 'Yolculuk öncesi süre',
    travelDistanceBefore: 'Yolculuk öncesi mesafe (km)',
    visitStartDate: 'Vizit başlangıç tarihi',
    visitStartTime: 'Vizit başlangıç saati',
    visitEndDate: 'Vizit bitiş tarihi',
    visitEndTime: 'Vizit bitiş saati',
    visitDuration: 'Vizit süresi',
    travelAfter: 'Yolculuk sonrası süre',
    issueOccurred: 'Sorun oluştu mu?',
    issueResultedInMiss: 'Sorun vizitin kaçırılmasına neden oldu mu?',
    issueSource: 'Sorun kaynağı',
    dateInitialSourceReceived: 'İlk kaynak alınma tarihi',
    dateSourceFinalized: 'Kaynak kesinleşme tarihi',
    wasAeSaeTaken: 'AE/SAE alındı mı?',
    dcfCreated: 'DCF oluşturuldu mu?',
    screenFail: 'Screen fail?',
    dropPatient: 'Drop patient?',
    protocolDeviation: 'Protokol sapması',
    capaOpened: 'CAPA açıldı mı?',
    processEndDate: 'Süreç bitiş tarihi',
    slaTarget: 'SLA hedefi',
    issueCategory: 'Sorun kategorisi',
    issueDetails: 'Sorun detayları',
  },
  stock: {
    add: 'Malzeme Ekle',
    count_one: '{{count}} malzeme',
    count_other: '{{count}} malzeme',
    requiredNote: 'Yapılacaklar listesinde “Stok girişi yapılacak” işaretli. Vizit tamamlanmadan önce en az bir malzeme ekleyin.',
    requiredDone: 'Stok girişi tamam: bu vizit için malzeme girildi.',
    optionalNote: 'Vizitte malzeme kullanmadıysanız bu adımı atlayabilirsiniz.',
    emptyTitle: 'Henüz malzeme eklenmemiş',
    emptyText: 'Vizitte kullandığınız malzemeleri “Malzeme Ekle” ile kaydedin.',
    columns: {
      name: 'Malzeme adı',
      type: 'Stok tipi',
      quantity: 'Kullanım sayısı',
      reason: 'Kullanım nedeni',
      addedAt: 'Eklenme tarihi',
      action: 'İşlem',
    },
    remove: 'Kaldır',
    confirmRemove: {
      title: 'Malzeme kaldırılsın mı?',
      message: 'Bu malzemeyi kaldırmak istediğinizden emin misiniz? Kullanılan miktar stoğunuza geri eklenir.',
      confirm: 'Evet, kaldır',
    },
    dialog: {
      title: 'Malzeme Ekle',
      subtitle: 'Ziyaret için kullanılacak malzemeyi seçin',
      stock: 'Stok seçin',
      assignedOnly: 'Yalnızca size atanan ve kalanı olan stoklar gösterilir.',
      placeholder: 'Stok seçiniz...',
      none: 'Size atanmış stok bulunamadı',
      option: '{{name}} - {{type}} (Kalan: {{remaining}} adet)',
      selectedInfo: 'Seçilen stok bilgileri',
      stockName: 'Stok adı',
      stockType: 'Stok tipi',
      available: 'Mevcut miktar',
      availableValue: '{{count}} adet',
      status: 'Durum',
      active: 'Aktif',
      inactive: 'İnaktif',
      quantity: 'Kullanım miktarı',
      quantityPlaceholder: 'Kullanılacak miktar',
      reason: 'Kullanım nedeni',
      reasonPlaceholder: 'Malzemenin kullanım nedeni...',
      add: 'Ekle',
      adding: 'Ekleniyor...',
      cancel: 'İptal',
    },
  },
  expenses: {
    refresh: 'Yenile',
    refreshHint: 'Masrafları yeniden yükle',
    add: 'Masraf Ekle',
    total: 'Toplam',
    count_one: '{{count}} masraf',
    count_other: '{{count}} masraf',
    emptyTitle: 'Henüz masraf yok',
    emptyText: 'Vizit için yaptığınız harcamaları fişi veya faturasıyla birlikte “Masraf Ekle” ile kaydedin.',
    columns: {
      name: 'Ad',
      type: 'Tip',
      cost: 'Maliyet',
      info: 'Bilgi',
      files: 'Dosyalar',
      date: 'Tarih',
    },
    types: {
      transportation: 'Ulaşım',
      accommodation: 'Konaklama',
      meal: 'Yemek',
      supplies: 'Malzeme',
      other: 'Diğer',
    },
    amount: '{{value}} TL',
    fileFallback: 'Dosya',
    dialog: {
      title: 'Masraf Ekle',
      subtitle: 'Harcamayı fişi veya faturasıyla birlikte kaydedin',
      name: 'Masraf adı',
      namePlaceholder: 'Masraf adını giriniz',
      cost: 'Maliyet',
      type: 'Masraf tipi',
      info: 'Bilgi',
      infoPlaceholder: 'Masraf hakkında ek bilgi giriniz...',
      optional: '(isteğe bağlı)',
      files: 'Dosya ekle',
      filesHint: '(fatura, makbuz vb.)',
      drop: 'Dosyaları buraya sürükleyin veya',
      dropLink: 'seçmek için tıklayın',
      dropHint: 'PNG, JPG, WEBP, PDF - en fazla 5 MB',
      uploading: 'Dosyalar yükleniyor...',
      preview: 'Önizle',
      delete: 'Sil',
      cancel: 'İptal',
      save: 'Kaydet',
      saving: 'Kaydediliyor...',
    },
  },
  shipments: {
    summary: {
      total: 'Toplam',
      notSent: 'Verilmedi',
      shipped: 'Kargoda',
      delivered: 'Teslim',
      cost: 'Kargo bedeli',
    },
    add: 'Kargo Ekle',
    emptyTitle: 'Henüz kargo kaydı yok',
    emptyText: 'Bu ziyaret için gönderilen malzemeleri, takip numarasını ve kargo belgelerini burada takip edebilirsiniz.',
    firstRecord: 'İlk kaydı ekle',
    edit: 'Düzenle',
    delete: 'Sil',
    sentOn: 'Gönderim: {{date}}',
    deliveredOn: 'Teslim: {{date}}',
    costLabel: 'Kargo bedeli:',
    trackingNo: 'Takip No',
    copy: 'Takip numarasını kopyala',
    openCarrier: '{{carrier}} sitesinde sorgula',
    markAs: '{{status}} olarak işaretle',
    status: {
      not_sent: 'Kargoya Verilmedi',
      shipped: 'Kargoya Verildi',
      delivered: 'Teslim Edildi',
      returned: 'İade / Sorunlu',
    },
    carriers: {
      kurye: 'Kurye / Elden Teslim',
      diger: 'Diğer',
    },
    confirmDelete: {
      title: 'Kargo kaydı silinsin mi?',
      message: '“{{subject}}” kargo kaydı silinsin mi? Bu işlem geri alınamaz.',
      confirm: 'Evet, sil',
    },
    dialog: {
      titleNew: 'Yeni Kargo Kaydı',
      titleEdit: 'Kargo Kaydını Düzenle',
      subtitle: 'Gönderiyi, alıcıyı ve kargo belgelerini kaydedin',
      sections: {
        details: 'Gönderi bilgileri',
        status: 'Kargo durumu',
        recipient: 'Alıcı ve adres',
        files: 'Dosyalar',
        note: 'Not',
      },
      subject: 'Konu başlığı',
      subjectPlaceholder: 'Örn. Lab kiti gönderimi',
      content: 'İçerik',
      contentPlaceholder: 'Kutuda ne var? Malzeme adı, adet, lot numarası...',
      statusHint: 'Durumu değiştirdiğinizde tarihler otomatik dolar; dilerseniz düzenleyebilirsiniz.',
      carrier: 'Kargo firması',
      carrierPlaceholder: 'Seçiniz...',
      trackingNumber: 'Kargo takip no',
      trackingPlaceholder: 'Takip numarası',
      shippedAt: 'Kargoya veriliş tarihi',
      deliveredAt: 'Teslim tarihi',
      cost: 'Kargo bedeli',
      costPlaceholder: '0,00',
      recipientName: 'Kime gönderildi',
      recipientNamePlaceholder: 'Ad soyad',
      recipientOrg: 'Kurum / merkez',
      recipientOrgPlaceholder: 'Hastane, merkez veya firma',
      recipientPhone: 'Alıcı telefonu',
      recipientPhonePlaceholder: '05xx xxx xx xx',
      senderName: 'Gönderen',
      senderNamePlaceholder: 'Gönderen kişi',
      destination: 'Nereye gönderildi (adres)',
      destinationPlaceholder: 'Teslimat adresi',
      drop: 'Kargo fişi, irsaliye veya teslim tutanağını sürükleyin ya da seçmek için tıklayın',
      uploading: 'Yükleniyor...',
      dropHint: 'PDF, görsel, Word veya Excel · en fazla 10 MB',
      removeFile: 'Dosyayı sil',
      note: 'Not',
      notePlaceholder: 'Eklemek istediğiniz not',
      cancel: 'Vazgeç',
      save: 'Kaydet',
      update: 'Güncelle',
      saving: 'Kaydediliyor...',
    },
  },
  evaluation: {
    summary: {
      visitType: 'Ziyaret tipi',
      duration: 'Vizit süresi',
      durationValue: '{{value}} saat',
      cycleTime: 'Cycle time',
      sla: 'SLA',
      slaMet: 'Karşılandı',
      slaOverdue: 'Aşıldı',
    },
    home: {
      A: { title: 'Kimlik', hint: 'Hasta ID ve vizit numarası Ziyaret Formu’ndan gelir.' },
      B: { title: 'Pencere / Zamanlama', hint: 'Protokole göre vizit penceresinin açılış, hedef ve kapanış tarihleri.' },
      C: { title: 'Planlanan', hint: 'Vizitin planlandığı tarih ve saat ile vizite gidecek klinisyen.' },
      D: { title: 'Yolculuk Öncesi', hint: 'Vizite gidiş için harcanan süre (saat ve dakika) ve mesafe.' },
      E: { title: 'Vizit Detayları', hint: 'Vizitin gerçekte başladığı ve bittiği an ile toplam süresi.' },
      F: { title: 'Yolculuk Sonrası', hint: 'Vizitten dönüş için harcanan süre.' },
      G: { title: 'Sorun Bilgisi', hint: 'Vizitte sorun yaşandıysa kaynağını ve vizitin kaçırılmasına yol açıp açmadığını belirtin.' },
      H: { title: 'Kalite İncelemesi', hint: 'Yalnızca yöneticiler görür: düzeltme talepleri ve nedenleri.' },
      I: { title: 'Kaynak Tarihleri', hint: 'Kaynak dokümanın ilk alındığı, son revizyonun istendiği ve kesinleştiği tarihler.' },
      J: { title: 'Sonuç', hint: 'Vizit sonunda AE/SAE alınıp alınmadığı ve DCF oluşturulup oluşturulmadığı.' },
    },
    site: {
      A: { title: 'Visit Özet Bilgileri', hint: 'Proje ve vizit bilgilerinin özeti. Gerekirse hasta ID’sini burada düzeltebilirsiniz.' },
      B: { title: 'Hasta Durumu', hint: 'Hastanın tarama başarısızlığı (screen fail) veya çalışmadan ayrılma (drop) durumu.' },
      C: { title: 'Protokol & CAPA', hint: 'Protokolden sapma olduysa CAPA açılıp açılmadığını belirtin ve notlarınızı ekleyin.' },
      D: { title: 'Tamamlanma Tarihleri', hint: 'eCRF, kaynak doküman ve imzaların tamamlandığı tarih ve saatler.' },
      E: { title: 'Süreç & SLA', hint: 'Süreç bitiş tarihi ve SLA hedefi. Cycle time ve SLA sonucu otomatik hesaplanır.' },
      F: { title: 'Sorun Takibi', hint: 'Vizitte sorun yaşandıysa kategorisini ve ayrıntılarını yazın.' },
    },
    optionalSection: 'Bu bölüm vizitin tamamlanmasını engellemez. Girilmeyen tarihler vizitte “eksik” olarak işaretlenir ve sonradan girdiğinizde uyarı kalkar.',
    adminOnly: 'Yalnızca yönetici',
    fields: {
      patientId: 'Hasta ID',
      visitId: 'Vizit ID',
      windowOpenDate: 'Pencere açılış',
      targetDate: 'Hedef tarih',
      windowCloseDate: 'Pencere kapanış',
      clinician: 'Klinisyen',
      clinicianPlaceholder: 'Klinisyenin adı soyadı',
      plannedDate: 'Planlanan tarih',
      plannedTime: 'Planlanan saat',
      travelTime: 'Süre',
      distance: 'Mesafe (km)',
      visitStartDate: 'Vizit başlangıç tarihi',
      visitStartTime: 'Vizit başlangıç saati',
      visitEndDate: 'Vizit bitiş tarihi',
      visitEndTime: 'Vizit bitiş saati',
      visitDuration: 'Vizit süresi',
      issueOccurred: 'Sorun oluştu mu?',
      issueResultedInMiss: 'Sorun vizitin kaçırılmasına neden oldu mu?',
      issueSource: 'Sorun kaynağı',
      issueSourcePlaceholder: 'Sorun kaynağı...',
      smoCorrectionRequests: 'SMO düzeltme talepleri',
      smoCorrectionRequestsPlaceholder: 'Düzeltme talebi sayısı',
      qualityManagerCheck: 'Klinik PM düzeltmeleri',
      qualityManagerCheckPlaceholder: 'Klinik PM düzeltmeleri...',
      correctionReason: 'Düzeltme nedeni',
      correctionReasonPlaceholder: 'Düzeltme nedeni...',
      dateInitialSourceReceived: 'İlk kaynak alınma tarihi',
      dateLatestSourceRevision: 'CPM’den son revizyon talebi',
      dateSourceFinalized: 'Kaynak kesinleşme tarihi',
      wasAeSaeTaken: 'AE/SAE alındı mı?',
      dcfCreated: 'DCF oluşturuldu mu?',
      projectName: 'Proje adı',
      centerId: 'Merkez ID',
      visitType: 'Vizit tipi',
      siteVisitType: 'Hastane (Site)',
      siteCoordinator: 'Site koordinatörü',
      sitePatientPlaceholder: 'Hasta ID giriniz...',
      visitDate: 'Vizit tarihi',
      screenFail: 'Screen fail?',
      dropPatient: 'Drop patient?',
      protocolDeviation: 'Protokol sapması (protocol deviation) var mı?',
      capaOpened: 'CAPA açıldı mı?',
      comments: 'Yorumlar',
      commentsPlaceholder: 'Vizite ilişkin notlar ve yorumlar...',
      ecrf: 'eCRF',
      sourceDoc: 'Kaynak doküman',
      signature: 'İmza',
      completionDate: 'Tamamlanma tarihi',
      completionTime: 'Tamamlanma saati',
      sourceDocCompleted: 'Kaynak doküman tamamlandı mı?',
      sourceDocCompletionTime: 'Kaynak dok. tamamlanma saati',
      processEndDate: 'Süreç bitiş tarihi (process end date)',
      cycleTime: 'Cycle time (gün)',
      slaTarget: 'SLA hedefi (gün)',
      slaTargetPlaceholder: 'Hedef gün sayısı',
      slaMet: 'SLA karşılandı mı?',
      slaOverdue: 'SLA aşıldı mı?',
      autoCalculated: 'Otomatik hesaplanır',
      issueCategory: 'Sorun kategorisi',
      issueDetails: 'Sorun detayları',
      issueDetailsPlaceholder: 'Sorunun ayrıntıları...',
    },
    issueCategories: {
      iv_access: 'IV Erişim',
      patient_compliance: 'Hasta Uyumu',
      documentation: 'Dokümantasyon',
      logistics: 'Lojistik',
      protocol: 'Protokol',
      equipment: 'Ekipman',
      other: 'Diğer',
    },
  },
  cra: {
    status: 'Durum: {{state}}',
    sent: 'Gönderildi',
    notSent: 'Gönderilmedi',
    expenseWarning_one: 'Bu ziyarette {{count}} adet harcama bulunmaktadır. CRA seçimi zorunludur.',
    expenseWarning_other: 'Bu ziyarette {{count}} adet harcama bulunmaktadır. CRA seçimi zorunludur.',
    cra: 'CRA',
    selectRequired: 'CRA Seçiniz (Zorunlu)',
    select: 'Lütfen Seçiniz',
    send: 'Gönder',
    resend: 'Tekrar Gönder',
    sending: 'Gönderiliyor...',
  },
};

export default visitModal;
